window.APP = (function(window, document, $, undefined)
{


	'use strict';

	if(app === undefined)
	{

		var app = {

			config : {},
			pages  : {},
			load   : {},
            t      : null

		};

	}

	/**
	 *
	 *  App initialize
	 *
	 */
	app.init = function()
	{

        $.getJSON(
            app.config.url.language +
            app.config.lang         + '.json', function(data)
        {

            app.t = function(key, obj)
            {

                return (obj == undefined) ? data[key] : data[obj][key];

            };

            $.each(app.load, function(key, value)
            {

                app.load[key](value);

            });

        });

	};


	app.load.contact = function () {
		// email validation
		function validateEmail(email) {
		    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    return re.test(email);
		}


		// contact form
		if ( $('.contact-form').length > 0 ) {

			var site_url = $('.contact-form').attr('data-url');

			$('.contact-form .submit').on('click', function(event) {
				event.preventDefault();
				$('.contact-form').submit();
				$(this).addClass('disable-click');
			});

			$('.contact-form').submit(function(event) {

				event.preventDefault();

				var name 		= $(this).find('#name'),
					email 		= $(this).find('#email'),
					subject 	= $(this).find('#phone'),
					textarea 	= $(this).find('#textarea'),
					err 		= 0;


				$(this).find('input,select,textarea').each(function(index, el) {

					if ($(this).val() == ""){
						$(this).addClass('error');
						err = 1 + $($(this)).attr('id');
					}else{
						$(this).closest('.form-group').removeClass('error');
					}

				});

				// email
				if ( email.val() != "" && validateEmail( email.val() ) ) {
					email.removeClass('error');
				}else{
					email.addClass('error');
					err = 1  + "em2";
				}

				// Remove Validation Errors
				$('.error').on('click', function(event) {
					$(this).removeClass('error');
					$('.contact-form .submit').removeClass('disable-click');
				});


				if ( err == 0 ) {

					$.ajax({
						url: site_url + '/wp-admin/admin-ajax.php',
		        		type: 'POST',
		        		data: {
		          			action 		: 'mail_send',
		          			name 		: name.val(),
							email 		: email.val(),
							subject 	: subject.val(),
							textarea 	: textarea.val(),

		        		},
		        		success : function(data){

			          			var obj = JSON.parse(data);

			          			if(obj.message == "success")
			          			{

			          				$('div.submit').after('<p class="success-message">'+APP.config.emailSendNotification+'</p> ');

		          					$('div.submit').closest('form').find("input, textarea").val("");

			          				// $('div.submit').unbind("click");
		        			        setTimeout(function(){
		        			        	$( ".success-message" ).remove();
							        }, 2000);
			          			}
		        		},
		        		error: function(data){
		        			$('div.submit').after('<p class="error-message">'+APP.config.emailFailed+'</p> ');
        			        setTimeout(function(){
        			        	$( ".error-message" ).remove();
					        }, 2000);
		        		}
					});

				};

			});

		};
	}



	/*
	* Hash
	*/
	let getHashUrl = () => {

		let hash = window.location.hash.substring(1),
			hashFilterObj = JSON.parse('{"' + decodeURI(hash).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

			return hashFilterObj;
	}


	/*
	*
	* Products Filter
	* 
	*/
	app.load.productsFilter = () => {

		let container = $('#product-list .product-list-items');

		// prodcuts get by filter
		let getProducts = ( paged = 1 ) => {

			let filterObj = {
				paged : paged,
				tax : '',
			};

			$('[name="category"]:checked').each(function(index, el) {

				let value 	= $(el).val(),
					rel 	= 'tax';

				if ( filterObj[rel] != "" ) {
					 value = value + ',' + filterObj[rel];
				}

				filterObj[rel] = value;

			});

			container.getProducts( filterObj );

		}


		// prdocuts page
		if ( container.length ) {

			// check if hash
			if( window.location.hash ) {

				let hashFilterObj = getHashUrl();
				container.getProducts( hashFilterObj );

				$.each( hashFilterObj, (key, elVal) => {

					if ( key == 'tax' ) {

						var array = JSON.parse("[" + elVal + "]");
						
						$.each(array, function(index, val) {
							
							$('[name="category"][value="' + val + '"]').prop('checked', true);

						});

					};

				});


			}else {

				// call products 
				getProducts();

			}


			// call products after change
			$('[name="category"]').change(function() {

				getProducts();

			});


			$('#product-list').on('click', '.page-numbers:not(.current)', function(event) {
				
				event.preventDefault();

				let page = $(this).text();
				getProducts( page );

			});

		};
		

	}



	/*
	*
	* Scroll down button animation
	* 
	*/
	app.load.scrollAnimation = () => {

		if ( $('.scroll-down').length ) {

			var gradient_percent = 0,
			    gradient_offset = {
			      	min: -40,
			      	max: 140
			    },
			    speed = 2,
			    gradient_color = 'rgba(255, 255, 255, 1)',
			    empty_color = 'rgba(0, 0, 0 , 0)';

			setInterval(function() {
				
			  	gradient_percent += speed;
			  
			  	if (gradient_percent > gradient_offset.max) {
			    	gradient_percent = gradient_offset.min;
			  	}
			  
			  	$('.scroll-down span.mask').css('background-image', '-webkit-radial-gradient('+ gradient_percent +'% 50%, 3em 2em, ' + gradient_color + ' 0%, ' + empty_color + ' 100%)');

			}, 17);

		};

	}


	$(document).ready(app.init);

	return app;

}) (window, document, jQuery);
